module.exports = __webpack_public_path__ + "public/media/img_smallmove_guide_mobile.1245a905.jpg";